/**
 * CSRF token for cookie-authenticated mutations. In deployments where web and admin use
 * different hostnames, the API sets `tc_csrf` on their configured shared parent domain. The
 * session cookie remains HTTP-only and host-only on the API host.
 */
export const CSRF_COOKIE = 'tc_csrf';

export function readCsrfToken(cookieString: string = safeDocumentCookie()): string | null {
  for (const part of cookieString.split(';')) {
    const [rawName, ...rest] = part.split('=');
    if (rawName?.trim() === CSRF_COOKIE) {
      const value = rest.join('=').trim();
      if (!value) return null;
      try {
        return decodeURIComponent(value);
      } catch {
        return value;
      }
    }
  }
  return null;
}

function safeDocumentCookie(): string {
  try {
    return typeof document === 'undefined' ? '' : document.cookie;
  } catch {
    return '';
  }
}
